export const songs = [
  {
    name: "Walking Promises",
    artist: "Harry Jackson, Virginia Hassis",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-10.mp3",
    img: "/Images/s1.jpg" 
  },
  {
    name: "Desired Games",
    artist: "Harry Jackson, Virginia Hassis",
    src: "/audio/bensound-rightnow.mp3",
    img: "/Images/s2.jpg"
  },
  {
    name: "Don't Let Me Down",
    artist: "Harry Jackson, Virginia Hassis",
    src: "/audio/bensound-rebelsofourownkind.mp3",
    img: "/Images/s3.jpg"
  },
  {
    name: "Dark Alley Acoustic",
    artist: "Harry Jackson, Virginia Hassis",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
    img: "/Images/s4.jpg"
  },
  {
    name: "Until I Met You",
    artist: "Harry Jackson, Virginia Hassis",
    src: "/audio/bensound-ngl.mp3",
    img: "/Images/s5.jpg"
  },
  {
    name: "Desires Pending",
    artist: "Harry Jackson, Virginia Hassis",
    src: "/audio/bensound-rightnow.mp3",
    img: "/Images/s6.jpg"
  },
  {
    name: "Lonely Nights",
    artist: "Harry Jackson, Virginia Hassis",
    src: "/audio/bensound-patience.mp3",
    img: "/Images/s1.jpg"
  },
  {
    name: "City Lights",
    artist: "Harry Jackson, Virginia Hassis",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-12.mp3",
    img: "/Images/s2.jpg"
  },
  {
    name: "Rainy Thoughts",
    artist: "Harry Jackson, Virginia Hassis",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-9.mp3",
    img: "/Images/s3.jpg"
  },
//   {
//     name: "Ocean Drive",
//     artist: "Harry Jackson, Virginia Hassis",
//     src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-10.mp3",
//     img: "/Images/s4.jpg"
//   },
//   {
//     name: "Winter Breeze",
//     artist: "Harry Jackson, Virginia Hassis",
//     src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-11.mp3",
//     img: "/Images/s5.jpg"
//   },
//   {
//     name: "Forever Yours",
//     artist: "Harry Jackson, Virginia Hassis",
//     src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-12.mp3",
//     img: "/Images/s6.jpg"
//   },
//   {
//     name: "Mountain Echo",
//     artist: "Harry Jackson, Virginia Hassis",
//     src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-13.mp3",
//     img: "/Images/s1.jpg"
//   },
//   {
//     name: "Sunset Chill",
//     artist: "Harry Jackson, Virginia Hassis",
//     src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-14.mp3",
//     img: "/Images/s2.jpg"
//   },
];